(function () {
  class Loan extends Common {
    constructor() {
      super()
    };

    toggleNationalityCountry() {
      const operation = this;

      function toggle() {
        var selected = $(operation.ui.loanCustomerNationality).val();
        if (selected && selected !== 'national') {
          $('#nationality_country_field').removeClass('d-none');
          $(operation.ui.loanCustomerNationalityCountry).prop('required', true);
        } else {
          $('#nationality_country_field').addClass('d-none');
          $(operation.ui.loanCustomerNationalityCountry).prop('required', false);
          $(operation.ui.loanCustomerNationalityCountry).val('');
        }
      }

      $(operation.ui.loanCustomerNationality).on('change', toggle);
      toggle();
    }

    togglePepFields() {
      const operation = this;

      function togglePep() {
        var isPep = $(operation.ui.customerIsPep).val();
        if (isPep === 'true') {
          $(operation.ui.customerPepContainer).removeClass('d-none');
        } else {
          $(operation.ui.customerPepContainer).addClass('d-none');
          $("#loan_customer_detail_attributes_pep_from_at").val('');
          $("#loan_customer_detail_attributes_pep_to_at").val('');
          $("input[name='loan[customer_detail_attributes][pep_functions][]']").prop('checked', false);
          $("#loan_customer_detail_attributes_pep_function_other").val('');
          $(operation.ui.customerPepFunctionsOtherContainer).addClass('d-none');
        }
      }

      function togglePepOther() {
        var checked = $("input[name='loan[customer_detail_attributes][pep_functions][]'][value='other']").is(':checked');
        if (checked) {
          $(operation.ui.customerPepFunctionsOtherContainer).removeClass('d-none');
        } else {
          $(operation.ui.customerPepFunctionsOtherContainer).addClass('d-none');
          $("#loan_customer_detail_attributes_pep_function_other").val('');
        }
      }

      function toggleFamilyPep() {
        var familyIsPep = $(operation.ui.customerFamilyIsPep).val();
        if (familyIsPep === 'true') {
          $(operation.ui.customerFamilyPepContainer).removeClass('d-none');
        } else {
          $(operation.ui.customerFamilyPepContainer).addClass('d-none');
          $(operation.ui.customerFamilyPepRelationship).val('');
          $("#loan_customer_detail_attributes_family_pep_relationship_other").val('');
          $(operation.ui.customerFamilyPepRelationshipOtherContainer).addClass('d-none');
        }
      }

      function toggleFamilyPepOther() {
        var rel = $(operation.ui.customerFamilyPepRelationship).val();
        if (rel === 'other') {
          $(operation.ui.customerFamilyPepRelationshipOtherContainer).removeClass('d-none');
        } else {
          $(operation.ui.customerFamilyPepRelationshipOtherContainer).addClass('d-none');
          $("#loan_customer_detail_attributes_family_pep_relationship_other").val('');
        }
      }

      $(operation.ui.customerIsPep).on('change', togglePep);
      $(document).on('change', "input[name='loan[customer_detail_attributes][pep_functions][]']", togglePepOther);
      $(operation.ui.customerFamilyIsPep).on('change', toggleFamilyPep);
      $(operation.ui.customerFamilyPepRelationship).on('change', toggleFamilyPepOther);

      togglePep();
      togglePepOther();
      toggleFamilyPep();
      toggleFamilyPepOther();
    }

    configure() {
      // BY ID
      this.ui.companyID = "#loan_company_id";
      this.ui.phoneImei = "#loan_details_phone_loan_attributes_imei";
      this.ui.phoneImeiConfirmation = "#loan_details_phone_loan_attributes_imei_confirmation";
      this.ui.customerId = "#loan_customer_attributes_id";
      this.ui.customerFirstName = "#loan_customer_attributes_first_name";
      this.ui.customerSecondName = "#loan_customer_attributes_second_name";
      this.ui.customerFirstLastName = "#loan_customer_attributes_first_last_name";
      this.ui.customerSecondLastName = "#loan_customer_attributes_second_last_name";
      this.ui.customerEmail = "#loan_customer_detail_attributes_email";
      this.ui.customerReferenceName1 = "#loan_customer_detail_attributes_first_fullname_reference";
      this.ui.customerReferenceNumber1 = "#loan_customer_detail_attributes_first_number_reference";
      this.ui.customerReferenceName2 = "#loan_customer_detail_attributes_second_fullname_reference";
      this.ui.customerReferenceNumber2 = "#loan_customer_detail_attributes_second_number_reference";
      this.ui.customerIdNumber = "#loan_customer_attributes_id_number";
      this.ui.customerIdNumberConfirmation = "#loan_customer_attributes_id_number_confirmation";
      this.ui.customerBirthDate = "#loan_customer_attributes_birth_date";
      this.ui.customerGender = "#loan_customer_attributes_gender";
      this.ui.customerProvinceId = "#loan_customer_detail_attributes_province_id";
      this.ui.customerDistrictId = "#loan_customer_detail_attributes_district_id";
      this.ui.customerJurisdictionId = "#loan_customer_detail_attributes_jurisdiction_id";
      this.ui.customerStreet = "#loan_customer_detail_attributes_address_street";
      this.ui.customerHomeName = "#loan_customer_detail_attributes_address_house_name";
      this.ui.customerHouseNumber = "#loan_customer_detail_attributes_address_house_number";
      this.ui.customerMaritalStatus = "#loan_customer_detail_attributes_marital_status";
      this.ui.customerPhotoFront = "#loan_customer_detail_attributes_id_photo_front";
      this.ui.customerPhotoBack = "#loan_customer_detail_attributes_id_photo_back";
      this.ui.customerPhotoWithUser = "#loan_customer_detail_attributes_id_photo_with_user";
      this.ui.customerSelfie = "#loan_customer_detail_attributes_selfie";
      this.ui.customerPhotoFrontTemp = "#photo_front_temp";
      this.ui.customerPhotoBackTemp = "#photo_back_temp";
      this.ui.customerSelfieTemp = "#photo_selfie_temp";
      this.ui.customerCellphone = "#loan_customer_detail_attributes_cellphone_number";
      this.ui.customerEconomicGroupId = "#loan_customer_detail_attributes_economic_group_id";
      this.ui.customerSwtich0 = "#customSwitch0";
      this.ui.customerSwtich1 = "#customSwitch1";
      this.ui.customerSwtich2 = "#customSwitch2";
      this.ui.customerSwtich3 = "#customSwitch3";

      this.ui.deviceBrandId = "#device_brand_id";
      this.ui.devicePrice = "#loan_details_phone_loan_attributes_device_price";
      this.ui.percentageCompost = "input[name*='[percentage_compost_id]']:checked";
      this.ui.deviceModelId = "#loan_details_phone_loan_attributes_device_model_id";
      this.ui.paymentPeriodId = "input[name*='[payment_period_id]']:checked, input[name*='[payment_period]']:checked";
      this.ui.paymentPeriodWithoutChecked = "input[name*='[payment_period_id]'], input[name*='[payment_period]']";
      this.ui.paymentType = "input[name='loan[payment_type]']:checked, #loan_payment_type";
      this.ui.paymentTypeWithoutChecked = "input[name='loan[payment_type]'], #loan_payment_type";
      this.ui.loanAmount = "#loan_loan_amount";
      this.ui.result = "#result";
      this.ui.letterPreview = "#letter_preview";
      this.ui.loanCustomerNationality = "#loan_customer_attributes_nationality";
      this.ui.loanCustomerNationalityCountry = "#loan_customer_attributes_nationality_country";

      // PEP
      this.ui.customerIsPep = "#loan_customer_detail_attributes_is_pep";
      this.ui.customerPepContainer = "#pep_fields";
      this.ui.customerPepFunctionsOtherContainer = "#pep_function_other_field";
      this.ui.customerFamilyIsPep = "#loan_customer_detail_attributes_family_is_pep";
      this.ui.customerFamilyPepContainer = "#family_pep_fields";
      this.ui.customerFamilyPepRelationship = "#loan_customer_detail_attributes_family_pep_relationship";
      this.ui.customerFamilyPepRelationshipOtherContainer = "#family_pep_relationship_other_field";

      // BY Class
      this.ui.jsRootWeb = ".js-root-web";
      this.ui.jsCompany = ".js-company";
      this.ui.jsValidateDNI = ".js-validate-dni";
      this.ui.jsDevicePriceITBMS = ".js-device-price-itbms";
      this.ui.jsValidateUser = ".js-validate-user";

      // Step 3

      // Step 4
      this.ui.jsDevice = ".js-device";
      this.ui.jsFirstPaymentDate = ".js-first-payment-date";
      this.ui.jsLastPaymentDate = ".js-last-payment-date";
      this.ui.jsLetterQuantity = ".js-letter-quantity";
      this.ui.jsPaymentType = ".js-payment-type";
      this.ui.jsLetterPreview = ".js-letter-preview";

      this.ui.jsDevicePrice = ".js-device-price";
      this.ui.jsITBMS = ".js-itbms";
      this.ui.jsTotal = ".js-total";
      this.ui.jsInitialCompost = ".js-initial-compost";
      this.ui.jsLoanAmount = ".js-loan-amount";
      this.ui.jsPaymentLetter = ".js-payment-letter";
      this.ui.jsInterestCost = ".js-interest-cost";
      this.ui.jsTotalPayment = ".js-total-payment";
      this.ui.jsNextButton = "button.step_button--next";
      this.ui.jsFrontPhonto = ".js-front-photo";
      this.ui.jsBackPhoto = ".js-back-photo";
      this.ui.jsCustomerPhoto = ".js-customer-photo";
      this.ui.jsCustomerSelfie = ".js-customer-selfie";
      this.ui.jsFormMovileLoan = ".form-movile-loan";
      this.ui.jsInitialCompostPreview = ".js-initial-compost-preview";

      // step 5 - Datacultr
      this.ui.validateBtn = ".step_validate_datacultr";
      this.ui.loader = ".js-loading";
    };

    loadComponents() {
      this.configure();

      $("input[name*='[percentage_compost_id]']").first().prop('checked', true);
      $("input[name*='[payment_type]']").first().prop('checked', true);

      this.needFormValidation();
      this.textUpperCase();
      this.loadSelect2();
      this.loadSelect2Cascade("#device_brand_id", "#loan_details_phone_loan_attributes_device_model_id");
      this.loadSelect2Cascade("#loan_customer_detail_attributes_province_id", "#loan_customer_detail_attributes_district_id");
      this.loadSelect2Cascade("#loan_customer_detail_attributes_district_id", "#loan_customer_detail_attributes_jurisdiction_id");
      this.loadBrandsMaxPrice();
      this.onlyLetter();
      this.onlyNumber();
      this.maskedNumber();
      this.calculateSum();
      this.validateDNI();
      this.validateUser(true);
      this.prepareLoanDescription();
      this.changeLabelOnNationality();
      this.toggleNationalityCountry();
      this.togglePepFields();
      this.addValidatorDevicePrice();
      this.wizardStepValidation();
      this.loadCompanyID();
      this.bindDatacultrValidation();

      if (gon.global['integration_type']['equality'] || gon.global['integration_type']['veriff']) {
        this.convertImgToBase64(this.ui.customerPhotoFront, this.ui.customerPhotoFrontTemp);
        this.convertImgToBase64(this.ui.customerPhotoBack, this.ui.customerPhotoBackTemp);
        this.convertImgToBase64(this.ui.customerSelfie, this.ui.customerSelfieTemp);
        this.addValidatorIdentity();
      }

      if (document.documentElement.lang == 'es_nic') {
        this.loanPaymentType();
        $(this.ui.paymentTypeWithoutChecked).change();
      }

      $(this.ui.devicePrice).blur();

      $("#loan_customer_detail_attributes_cellphone_number").rules("add", {
        validateCellphone: { loan_id: "true" }
      });

      $("#loan_customer_detail_attributes_first_number_reference").rules('add', {
        validateCellphoneReference: true
      });

      $("#loan_customer_detail_attributes_second_number_reference").rules('add', {
        validateCellphoneReference: true
      });
    };

    loadDataCompanyID() {
      const operation = this;
      var options = $(operation.ui.companyID).find('option');

      options.each(function (idx, element) {
        var initialPayment = element.dataset["initialPayment"];
        $(this).data('initial-payment', initialPayment);
        $(element).removeAttr("data-initial-payment");
      });
    };

    loadCompanyID() {
      const operation = this;
      $(operation.ui.companyID).on('change', function () {
        $(operation.ui.deviceBrandId).change();
      });
    }

    loadBrandsMaxPrice() {
      const operation = this;

      $(operation.ui.deviceBrandId).on('change', function () {
        var selected = parseInt($(this).find('option:selected').val());
        var devices = $('.js-root-web').data('approvedDevices');
        var company_id = parseInt($(operation.ui.companyID).find('option:selected').val());
        $(this).data('query', '');
        if (Object.keys(devices).length !== 0) {
          var device = devices.filter(function (device) {
            return device.brands.includes(selected) || device.brands.length === 0;
          }).reduce(function (max, device) {
            return device.max_amount > max.max_amount ? device : max;
          });

          $(this).data('query', JSON.stringify({ max_price: device['max_amount'] }));
          operation.loadInitialPayments(device)
        } else {
          $(this).data('query', JSON.stringify({ company_id: company_id }));
        };
      });
    };

    loadInitialPayments(deviceSelected) {
      $("input[name*='[percentage_compost_id]']").each(function (idx, element) {
        $(element).addClass('d-none');
        $(element).closest('.form-check').addClass('d-none');
      });

      if (deviceSelected['initial_payments'].length === 0) {
        $("input[name*='[percentage_compost_id]']").each(function (idx, element) {
          $(element).removeClass('d-none');
          $(element).closest('.form-check').removeClass('d-none');
        });
      } else {
        for (const initial_payment of deviceSelected['initial_payments']) {
          var element = $("input[name*='[percentage_compost_id]'][data-id='" + initial_payment + "']");
          $(element).removeClass('d-none');
          $(element).closest('.form-check').removeClass('d-none');
        }
      }

      $("input[name*='[percentage_compost_id]']:not(.d-none):visible").first().prop('checked', true);
    };

    loanPaymentType() {
      const operation = this;
      $(operation.ui.paymentTypeWithoutChecked).on('change', function () {
        payment_type = $(operation.ui.paymentType).val();

        $(operation.ui.paymentPeriodWithoutChecked).each(function (idx, element) {
          var value = $(element).data('value');
          var quantity = 0;

          if (payment_type == "weekly") {
            quantity = 4 * value;
          } else if (payment_type == "monthly") {
            quantity = value;
          } else {
            quantity = 2 * value;
          };

          $(element).closest('.form-check').find('label').html(i18n.t('payment_period.' + payment_type, { count: quantity }));
        });
      });
    };

    calculateDevicePriceWithoutITBMS() {
      const itbms = Number($(this.ui.jsRootWeb).data('tax') / 100) + 1
      var device_price = Number($(this.ui.devicePrice).val().replaceAll(',', ''));
      var device_price_without_itbms = (device_price / itbms).toFixed(2);
      return Number(device_price_without_itbms);
    };

    calculateITBMS() {
      const operation = this;
      var country_tax = Number($(this.ui.jsRootWeb).data('tax') / 100)
      var device_price = operation.calculateDevicePriceWithoutITBMS();
      var itbms = (device_price * country_tax).toFixed(2);
      return Number(itbms);
    }

    calculateDevicePrice() {
      var device_price = Number($(this.ui.devicePrice).val().replaceAll(',', '')).toFixed(2);
      return Number(device_price);
    };

    calculateLoanAmount() {
      const operation = this;
      var price = operation.calculateDevicePrice();
      var percentage_compost = Number($(operation.ui.percentageCompost).data('value'));
      var loan_amount = (price - (price * (percentage_compost / 100))).toFixed(2);

      return Number(loan_amount);
    };

    calculateInitialCompost() {
      const operation = this;
      var price = operation.calculateDevicePrice();
      var percentage_compost = Number($(operation.ui.percentageCompost).data('value'));
      var initial_compost = (price * (percentage_compost / 100)).toFixed(2);

      $(operation.ui.jsInitialCompostPreview).text(Number(initial_compost).format());
    };

    calculateSum() {
      const operation = this;

      $(operation.ui.devicePrice).on('blur', function () {
        var price_without_itbms = operation.calculateDevicePriceWithoutITBMS()
        var loan_amount = operation.calculateLoanAmount();

        $(operation.ui.result).val(loan_amount);
        $(operation.ui.loanAmount).val(loan_amount);
        $(operation.ui.jsDevicePriceITBMS).text(price_without_itbms.format());
        operation.calculateLetterPreview();
        operation.calculateInitialCompost();
      })

      $(document).on('input', '.custom-percentage-compost', function () {
        var loan_amount = operation.calculateLoanAmount();
        $(operation.ui.result).val(loan_amount);
        $(operation.ui.loanAmount).val(loan_amount);
        operation.calculateLetterPreview();
        operation.calculateInitialCompost();
      });

      $(document).on('input', '#loan_payment_period_id', function () {
        operation.calculateLetterPreview();
        operation.calculateInitialCompost();
      })

      $(operation.ui.customerBirthDate).on('blur', function () {
        operation.calculateLetterPreview();
        operation.calculateInitialCompost();
      })

      $(operation.ui.customerGender).on('blur', function () {
        operation.calculateLetterPreview();
        operation.calculateInitialCompost();
      })
    };

    calculateSumStepAPC() {
      // Posible Dead Code
      const operation = this;

      $(operation.ui.devicePrice).on('blur', function () {
        var loan_amount = operation.calculateLoanAmount();
        $(operation.ui.result).val(loan_amount);
        operation.calculateInitialCompost();
        operation.calculateLetterPreview();
      })

      $(document).on('input', '.custom-percentage-compost', function () {
        var loan_amount = operation.calculateLoanAmount();
        $(operation.ui.result).val(loan_amount);
        operation.calculateInitialCompost();
        operation.calculateLetterPreview();
      });

      $(document).on('input', '#loan_payment_period_id', function () {
        operation.calculateLetterPreview();
        operation.calculateInitialCompost();
      })

      $(operation.ui.customerBirthDate).on('blur', function () {
        operation.calculateLetterPreview();
        operation.calculateInitialCompost();
      })

      $(operation.ui.customerGender).on('blur', function () {
        operation.calculateLetterPreview();
        operation.calculateInitialCompost();
      })
    };

    calculateLastPaymentDate(initialPaymentDate, letterQuantity) {
      const operation = this;
      var frecuency = $(operation.ui.paymentType).val();
      var item = new CalculatorLoanDates(initialPaymentDate);

      if (frecuency == "weekly") {
        return moment(item.calculateWeekly(letterQuantity)).format("DD/MM/YYYY");
      } else if (frecuency == "monthly") {
        return moment(item.calculateMonthly(letterQuantity)).format("DD/MM/YYYY");
      } else {
        return moment(item.calculateBiweekly(letterQuantity)).format("DD/MM/YYYY");
      }
    };

    validateDNI() {
      const operation = this;

      $(operation.ui.jsValidateDNI).on('blur', function () {
        var dni = this.value;
        $.ajax({
          method: 'GET',
          url: '/js_validate_unique_loan',
          data: { dni: dni }
        }).done(function (data) {
          console.log('done');
          if (typeof data !== 'undefined') {
            if (data.status) {
              bootbox.alert({
                message: data.messages,
              });
            }
          }
        }).fail(function () {
          console.log("error");
        });
      });
    };

    validateUser(allFields) {
      const operation = this;
      $(operation.ui.jsValidateUser).on('blur', function () {
        var dni = this.value;
        operation.resetFillForm(allFields);

        $.ajax({
          method: 'GET',
          url: '/js_load_existing_customer',
          data: { dni: dni }
        }).done(function (data) {
          var customer = data.result['customer'];
          var customerDetail = data.result['customer_detail'];
          operation.fillForm(allFields, customer, customerDetail);
        }).fail(function () {
        });
      });
    };

    resetFillForm(allFields) {
      const operation = this;
      $(operation.ui.customerId).val("");
      $(operation.ui.customerFirstName).val("");
      $(operation.ui.customerFirstLastName).val("");
      $(operation.ui.customerBirthDate).val("");
      $(operation.ui.customerGender).val("");

      if (allFields) {
        $(operation.ui.customerSecondName).val("");
        $(operation.ui.customerSecondLastName).val("");
        $(operation.ui.customerEmail).val("");
        $(operation.ui.customerReferenceName1).val("");
        $(operation.ui.customerReferenceNumber1).val("");
        $(operation.ui.customerReferenceName2).val("");
        $(operation.ui.customerReferenceNumber2).val("");
        $(operation.ui.customerProvinceId).val(null).trigger('change');
        $(operation.ui.customerDistrictId).val(null).trigger('change');
        $(operation.ui.customerJurisdictionId).val(null).trigger('change');
        $(operation.ui.customerStreet).val("");
        $(operation.ui.customerHomeName).val("");
        $(operation.ui.customerHouseNumber).val("");
        $(operation.ui.customerMaritalStatus).val("");
        $(operation.ui.customerEconomicGroupId).val(null).trigger('change');
        $(operation.ui.customerCellphone).val("");
      }
    };

    fillForm(allFields, customer, customerDetail) {
      const operation = this;
      $(operation.ui.customerId).val(customer['id']);
      $(operation.ui.customerFirstName).val(customer['first_name']);
      $(operation.ui.customerFirstLastName).val(customer['first_last_name']);
      $(operation.ui.customerBirthDate).val(customer['birth_date']);
      $(operation.ui.customerGender).val(customer['gender']);

      if (allFields) {
        $(operation.ui.customerSecondName).val(customer['second_name']);
        $(operation.ui.customerSecondLastName).val(customer['second_last_name']);

        if (customerDetail) {
          $(operation.ui.customerEmail).val(customerDetail['email']);
          $(operation.ui.customerReferenceName1).val(customerDetail['first_fullname_reference']);
          $(operation.ui.customerReferenceNumber1).val(customerDetail['first_number_reference']);
          $(operation.ui.customerReferenceName2).val(customerDetail['second_fullname_reference']);
          $(operation.ui.customerReferenceNumber2).val(customerDetail['second_number_reference']);
          $(operation.ui.customerProvinceId).val(customerDetail['province_id']).trigger('change');
          operation.addOptionSelect2(operation.ui.customerDistrictId, customerDetail['district_option_for_select']);
          operation.addOptionSelect2(operation.ui.customerJurisdictionId, customerDetail['jurisdiction_option_for_select']);
          $(operation.ui.customerStreet).val(customerDetail['address_street']);
          $(operation.ui.customerHomeName).val(customerDetail['address_house_name']);
          $(operation.ui.customerHouseNumber).val(customerDetail['address_house_number']);
          $(operation.ui.customerMaritalStatus).val(customerDetail['marital_status']);
          $(operation.ui.customerEconomicGroupId).val(customerDetail['economic_group_id']).trigger('change');
          $(operation.ui.customerCellphone).val(customerDetail['cellphone_number']);
        };
      };
    };

    prepareLoanDescription() {
      const operation = this;
      $(operation.ui.jsNextButton).on('click', function () {
        var interest = operation.getInterest();
        var payment_type = i18n.t('activerecord.enums.loan.payment_types.' + $(operation.ui.paymentType).val())
        var period_quantity = operation.getPaymentPeriod();
        var frecuency = operation.getPaymentFrecuency();
        var letter_quantity = (frecuency * period_quantity);
        var initial_payment_date = operation.getInitialPaymentDate();
        var first_payment = initial_payment_date.format("DD/MM/YYYY");
        var last_payment = operation.calculateLastPaymentDate(initial_payment_date, letter_quantity);
        var device_price = operation.calculateDevicePrice();
        var loan_amount = operation.calculateLoanAmount();
        var device_price_without_itbms = operation.calculateDevicePriceWithoutITBMS();
        var itbms = operation.calculateITBMS();
        var interest_cost = interest * loan_amount * period_quantity;
        var total_payment = loan_amount + interest_cost;
        //var letter_payment = total_payment / letter_quantity;

        $(operation.ui.jsDevice).text($(operation.ui.deviceModelId).find('option:selected').text());
        $(operation.ui.jsFirstPaymentDate).text(first_payment);
        $(operation.ui.jsLastPaymentDate).text(last_payment);
        $(operation.ui.jsLetterQuantity).text(letter_quantity);
        $(operation.ui.jsPaymentType).text(payment_type);

        // Calculate
        $(operation.ui.jsDevicePrice).text(device_price_without_itbms.format());
        $(operation.ui.jsITBMS).text(itbms.format());
        $(operation.ui.jsTotal).text((device_price * 1.00).format());
        $(operation.ui.jsInitialCompost).text(((device_price - loan_amount) * 1.00).format());
        $(operation.ui.jsLoanAmount).text(loan_amount.format());
        //$(operation.ui.jsInterestCost).text(interest_cost.toFixed(2));
        //$(operation.ui.jsTotalPayment).text(total_payment.toFixed(2));
        //$(operation.ui.jsPaymentLetter).text(Math.ceil(letter_payment).toFixed(2));
      });
    };

    calculateLetterPreview() {
      const operation = this;
      var interest = operation.getInterest();
      var period_quantity = operation.getPaymentPeriod();
      var frecuency = operation.getPaymentFrecuency();
      var letter_quantity = (frecuency * period_quantity);
      var loan_amount = Number($(operation.ui.result).val().replaceAll(',', ''));
      var interest_cost = interest * loan_amount * period_quantity;
      var total_payment = loan_amount + interest_cost;
      var letter_payment = total_payment / letter_quantity;

      if (gon.global.same_currency) {
        $(operation.ui.jsPaymentLetter).text(Math.ceil(letter_payment).toFixed(2));
        $(operation.ui.jsLetterPreview).text(Math.ceil(letter_payment).toFixed(2));
        $(operation.ui.letterPreview).val(Math.ceil(letter_payment).toFixed(2));
      } else {
        var exchangeRate = Number($(operation.ui.jsRootWeb).data('exchange-rate'));
        loan_amount = loan_amount / exchangeRate;
        interest_cost = interest_cost / exchangeRate;
        total_payment = total_payment / exchangeRate;
        letter_payment = total_payment / letter_quantity;
        letter_payment = (Math.ceil(letter_payment) * exchangeRate).toFixed(2)

        $(operation.ui.jsPaymentLetter).text(letter_payment);
        $(operation.ui.jsLetterPreview).text(letter_payment);
        $(operation.ui.letterPreview).val(letter_payment);
      };
    };

    changeLabelOnNationality() {
      const operation = this;
      $(operation.ui.loanCustomerNationality).on('change', function () {
        var selected = $(this).val();

        operation.getLabelNationality(selected);

        if ($(operation.ui.customerIdNumber).val() != "") {
          $(operation.ui.customerIdNumber).valid();
        };
      });
    };

    getLabelNationality(selected) {
      const operation = this;

      if (selected == "national") {
        $(operation.ui.customerIdNumber).addClass("formatDNI");
        $(operation.ui.customerIdNumber).rules('add', { formatDNI: true });
        $(operation.ui.jsFrontPhonto).text(i18n.t('activerecord.attributes.customer_detail.id_photo_front'))
        $(operation.ui.jsBackPhoto).text(i18n.t('activerecord.attributes.customer_detail.id_photo_back'))
        $(operation.ui.jsCustomerPhoto).text(i18n.t('activerecord.attributes.customer_detail.id_photo_with_user'))
      } else {
        $(operation.ui.customerIdNumber).removeClass("formatDNI");
        $(operation.ui.customerIdNumber).rules("remove", "formatDNI");
        $(operation.ui.jsFrontPhonto).text("Foto del pasaporte")
        $(operation.ui.jsBackPhoto).text("Foto del carné de residencia (Un año de vigencia mínimo)")
        $(operation.ui.jsCustomerPhoto).text("Foto del cliente con el carné de residencia")
      }
    };

    // For loan v1 Validation
    wizardStepValidation() {
      const operation = this;

      $(operation.ui.phoneImeiConfirmation).rules('add', {
        equalTo: operation.ui.phoneImei
      });

      $(operation.ui.customerIdNumberConfirmation).rules('add', {
        equalTo: operation.ui.customerIdNumber
      });

      $(operation.ui.customerBirthDate).rules('add', {
        maxAge: gon.global.max_age.cellular.max,
        minAge: gon.global.max_age.cellular.min
      });

      $(operation.ui.jsFormMovileLoan).on('click', function (e) {
        let element = e.target;
        let isButtonNext = element.classList.contains('step_button--next');
        let isButtonBack = element.classList.contains('step_button--back');
        let current_step = element.dataset.step;

        if (current_step == 1) {
          var validForm = !$(operation.ui.customerIdNumber).valid() || !$(operation.ui.customerIdNumberConfirmation).valid() || !$(operation.ui.deviceModelId).valid() ||
            !$(operation.ui.phoneImei).valid() || !$(operation.ui.phoneImeiConfirmation).valid() || !$(operation.ui.devicePrice).valid() ||
            !$(operation.ui.customerBirthDate).valid() || !$(operation.ui.customerGender).valid();

          if (validForm) {
            $(operation.ui.customerIdNumber).valid();
            $(operation.ui.customerIdNumberConfirmation).valid()
            $(operation.ui.deviceModelId).valid();
            $(operation.ui.phoneImei).valid();
            $(operation.ui.phoneImeiConfirmation).valid();
            $(operation.ui.devicePrice).valid();
            $(operation.ui.customerBirthDate).valid();
            $(operation.ui.customerGender).valid();
            $(".js-need-validation").find(":input.is-invalid:first").focus();
            return;
          }
        } else if (current_step == 2) {
          var validForm = !$(operation.ui.customerFirstName).valid() || !$(operation.ui.customerFirstLastName).valid() || !$(operation.ui.customerEmail).valid() ||
            !$(operation.ui.customerReferenceName1).valid() || !$(operation.ui.customerReferenceNumber1).valid() || !$(operation.ui.customerReferenceName2).valid() ||
            !$(operation.ui.customerReferenceNumber2).valid() || !$(operation.ui.customerProvinceId).valid() || !$(operation.ui.customerDistrictId).valid() ||
            !$(operation.ui.customerStreet).valid() || !$(operation.ui.customerHomeName).valid() || !$(operation.ui.customerHouseNumber).valid()

          if (['es', 'es_slv'].includes(document.documentElement.lang)) {
            validForm = validForm || !$(operation.ui.customerJurisdictionId).valid()
          };

          if (validForm) {
            $(operation.ui.customerFirstName).valid();
            $(operation.ui.customerFirstLastName).valid();
            $(operation.ui.customerEmail).valid();
            $(operation.ui.customerReferenceName1).valid();
            $(operation.ui.customerReferenceNumber1).valid();
            $(operation.ui.customerReferenceName2).valid();
            $(operation.ui.customerReferenceNumber2).valid();
            $(operation.ui.customerProvinceId).valid();
            $(operation.ui.customerDistrictId).valid();
            if (['es', 'es_slv'].includes(document.documentElement.lang)) {
              $(operation.ui.customerJurisdictionId).valid();
            };
            $(operation.ui.customerStreet).valid();
            $(operation.ui.customerHomeName).valid();
            $(operation.ui.customerHouseNumber).valid();
            $(".js-need-validation").find(":input.is-invalid:first").focus();
            return;
          }
        } else if (current_step == 3) {
          var validForm = !$(operation.ui.customerPhotoBack).valid() || !$(operation.ui.customerCellphone).valid() || !$(operation.ui.customerEconomicGroupId).valid()

          if (gon.global['integration_type']['equality'] || gon.global['integration_type']['veriff']) {
            if (!$(operation.ui.customerSwtich0).is(':checked')) {
              validForm = validForm || !$(operation.ui.customerPhotoFront).valid() || !$(operation.ui.customerPhotoWithUser).valid()
            }
          } else {
            validForm = validForm || !$(operation.ui.customerPhotoFront).valid() || !$(operation.ui.customerPhotoWithUser).valid()
          }


          if (validForm) {
            if (gon.global['integration_type']['equality'] || gon.global['integration_type']['veriff']) {
              if (!$(operation.ui.customerSwtich0).is(':checked')) {
                $(operation.ui.customerPhotoFront).valid();
                $(operation.ui.customerPhotoWithUser).valid();
              }
            } else {
              $(operation.ui.customerPhotoFront).valid();
              $(operation.ui.customerPhotoWithUser).valid();
            }
            $(operation.ui.customerPhotoBack).valid();
            $(operation.ui.customerCellphone).valid();
            $(operation.ui.customerEconomicGroupId).valid();
            $(".js-need-validation").find(":input.is-invalid:first").focus();
            return;
          }

          if (!$("#customSwitch0").prop("checked") || !$("#customSwitch1").prop("checked") || !$("#customSwitch2").prop("checked") || !$("#customSwitch3").prop("checked")) {
            Swal.fire({
              icon: "error",
              html: i18n.t('bootbox.errors.failed_check_switch'),
            });

            return;
          }
        }

        if (isButtonNext || isButtonBack) {
          let currentStep = document.getElementById('step-' + element.dataset.step);
          let jumpStep = document.getElementById('step-' + element.dataset.to_step);
          currentStep.classList.remove('active');
          jumpStep.classList.add('active');
          if (isButtonNext) {
            currentStep.classList.add('to-left');
          } else {
            jumpStep.classList.remove('to-left');
          }
          currentStep.classList.add('inactive');
          jumpStep.classList.remove('inactive');
        }
      });
    };

    calculateAge() {
      const operation = this;
      var birthDate = $(operation.ui.customerBirthDate).val();
      var birthDateDay = new Date(birthDate + "T00:00:00");
      var today = new Date();

      if ($(operation.ui.devicePrice).val() != "" || $(operation.ui.devicePrice).val() != 0) {
        var validForm = !$(operation.ui.customerBirthDate).valid() || !$(operation.ui.customerGender).valid();

        if (validForm) {
          $(operation.ui.customerBirthDate).valid();
          $(operation.ui.customerGender).valid();
          $(".js-need-validation").find(":input.is-invalid:first").focus();
          return;
        };
      };

      return parseInt(operation.currentAge(birthDate));
    };

    getPaymentPeriod() {
      const operation = this;
      const periods = $(operation.ui.jsRootWeb).data("payment-periods");
      const selectedId = Number($(operation.ui.paymentPeriodId).val());
      const matches = periods.filter((p) => p.id === selectedId);

      return (matches[0] && matches[0].value);
    };

    getPaymentFrecuency() {
      const operation = this;
      var frecuency = $(operation.ui.paymentType).val();

      if (frecuency == "weekly") {
        return 4;
      } else if (frecuency == "monthly") {
        return 1;
      } else {
        return 2;
      }
    };

    getInitialPaymentDate() {
      const operation = this;

      var frecuency = $(operation.ui.paymentType).val();

      if (frecuency == "weekly") {
        return moment(new Date()).add(7, 'days');
      } else if (frecuency == "monthly") {
        return moment(new Date()).add(1, 'months');
      } else {
        return moment(new Date()).add(14, 'days');
      }
    };

    getInterest() {
      const operation = this;
      var age = operation.calculateAge();
      var gender = $(operation.ui.customerGender).find("option:selected").val();
      var paymentPeriod = operation.getPaymentPeriod();
      var percentageCompostID = Number($(operation.ui.percentageCompost).val());

      if (typeof $(operation.ui.jsRootWeb).data('interest-rate')[paymentPeriod] === 'undefined' || typeof $(operation.ui.jsRootWeb).data('interest-rate')[paymentPeriod][percentageCompostID] === 'undefined') {
        Swal.fire({
          icon: "error",
          html: i18n.t('bootbox.no_inital_payment_html'),
          confirmButtonText: 'Aceptar'
        });

        return false;
      } else {
        var interest = $(operation.ui.jsRootWeb).data('interest-rate')[paymentPeriod][percentageCompostID];
      }

      if (gender == "female" && age >= gon.global.max_age.retired.female || gender == "male" && age >= gon.global.max_age.retired.male) {
        return ((interest - interest * 0.15) / 12 / 100);
      } else {
        return (interest / 12 / 100);
      }
    };

    modalMessages(element, url, msg_type) {
      const operation = this;
      $(element).on('click', function () {
        var validForm = !$(operation.ui.customerCellphone).valid();

        if (validForm) {
          $(operation.ui.customerCellphone).valid();
          $(".js-need-validation").find(":input.is-invalid:first").focus();
          $(this).prop('checked', false);

          return;
        }

        if ($(this).prop('checked')) {
          var first_name = $(operation.ui.customerFirstName).val();
          var last_name = $(operation.ui.customerFirstLastName).val();

          $.ajax({
            method: "POST",
            url: url,
            dataType: 'script',
            data: {
              loan_message: {
                msg_type: msg_type,
                dni: $(operation.ui.customerIdNumber).val(),
                cellphone: $(operation.ui.customerCellphone).val(),
                fullname: `${first_name} ${last_name}`,
                loan_type: 'cellular'
              }
            }
          }).done(function () {
            console.log("Done!");
          }).fail(function () {
            console.log("Error");
          });
        }
      });
    };

    addValidatorDevicePrice() {
      const operation = this;

      $(operation.ui.deviceModelId).on('select2:select', function (e) {
        var selectedData = e.params.data;
        var max_price = parseFloat(selectedData.max_price);

        $(operation.ui.devicePrice).val("");
        $(operation.ui.devicePrice).blur();

        $(operation.ui.devicePrice).rules('add', {
          maxPrice: max_price
        });
      });
    };

    addValidatorIdentity() {
      const operation = this;
      const veriffTimeoutSeconds = (gon.global['veriff_timeout'] || 10) * 1000;

      $(operation.ui.customerSwtich0).on('click', function (evt) {
        if (!$(this).is(':checked')) {
          return;
        }

        if (!$(operation.ui.customerPhotoFront).valid() || !$(operation.ui.customerPhotoBack).valid() || !$(operation.ui.customerPhotoWithUser).valid() || !$(operation.ui.customerSelfie).valid()) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          evt.stopPropagation();
        } else {
          var photo_front  = $(operation.ui.customerPhotoFrontTemp).val().split(',')[1];
          var photo_back   = $(operation.ui.customerPhotoBackTemp).val().split(',')[1];
          var photo_selfie = $(operation.ui.customerSelfieTemp).val().split(',')[1];

          // Bloquear el botón "Siguiente" mientras se procesa la verificación
          operation._blockNextButton(i18n.t('veriff.verifying'));

          bootbox.dialog({
            centerVertical: true,
            closeButton: false,
            message: i18n.t('bootbox.processing_html')
          });

          var ajaxTimeout = setTimeout(function() {
            operation.hideBootBox();
            operation._blockNextButton(i18n.t('veriff.timeout_error'));
          }, veriffTimeoutSeconds);

          $.ajax({
            method: "POST",
            url: "/providers/veriff/sessions",
            data: {
              customer_consent_id: $('#customer_consent_id').val(),
              first_name: $(operation.ui.customerFirstName).val(),
              last_name: $(operation.ui.customerFirstLastName).val() + ' ' + $(operation.ui.customerSecondLastName).val(),
              id_number: $(operation.ui.customerIdNumber).val(),
              photo_front:  photo_front,
              photo_back:   photo_back,
              photo_selfie: photo_selfie
            },
            dataType: 'json'
          }).done(function (data) {
            if (data.success) {
              // Guardar session_id en el formulario
              if ($('#loan_veriff_session_id').length === 0) {
                $('<input>').attr({
                  type: 'hidden',
                  id: 'loan_veriff_session_id',
                  name: 'loan[veriff_session_id]',
                  value: data.session_id
                }).appendTo('form');
              } else {
                $('#loan_veriff_session_id').val(data.session_id);
              }
              
              // Polling para esperar que el webhook actualice el status a "approved"
              var pollInterval = setInterval(function() {
                $.ajax({
                  method: "GET",
                  url: "/providers/veriff/sessions/" + data.session_id + "/status",
                  dataType: 'json'
                }).done(function(statusData) {
                  if (statusData.status === 'approved') {
                    clearInterval(pollInterval);
                    clearTimeout(ajaxTimeout);
                    operation.hideBootBox();
                    operation._unblockNextButton();
                  } else if (statusData.status === 'declined' || statusData.status === 'resubmission_requested' || statusData.status === 'abandoned') {
                    clearInterval(pollInterval);
                    clearTimeout(ajaxTimeout);
                    operation.hideBootBox();
                    operation._blockNextButton(i18n.t('veriff.verification_failed'));
                  }
                  // Si sigue "pending" o "veriff_pending", continúa el polling hasta que se acabe el ajaxTimeout
                }).fail(function() {
                  clearInterval(pollInterval);
                  clearTimeout(ajaxTimeout);
                  operation.hideBootBox();
                  operation._blockNextButton(i18n.t('veriff.verification_failed'));
                });
              }, 2000); // Consulta cada 2 segundos

              // Limpiamos el intervalo en caso de que ocurra el timeout general
              var originalTimeout = ajaxTimeout;
              ajaxTimeout = setTimeout(function() {
                clearInterval(pollInterval);
                operation.hideBootBox();
                operation._blockNextButton(i18n.t('veriff.timeout_error'));
              }, veriffTimeoutSeconds);
              clearTimeout(originalTimeout);

            } else {
              clearTimeout(ajaxTimeout);
              operation.hideBootBox();
              operation._blockNextButton(i18n.t('veriff.verification_failed'));
            }
          }).fail(function (jqXHR, textStatus) {
            clearTimeout(ajaxTimeout);
            operation.hideBootBox();
            var msg = textStatus === 'timeout' ? i18n.t('veriff.timeout_error') : i18n.t('veriff.verification_failed');
            operation._blockNextButton(msg);
          });
        }
      });

      $(operation.ui.customerPhotoFront).on('click', function (evt) {
        if ($(this).data('locked') === true) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          evt.stopPropagation();
        }
      });

      $(operation.ui.customerPhotoBack).on('click', function (evt) {
        if ($(this).data('locked') === true) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          evt.stopPropagation();
        }
      });

      $(operation.ui.customerPhotoWithUser).on('click', function (evt) {
        if ($(this).data('locked') === true) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          evt.stopPropagation();
        }
      });

      $(operation.ui.customerSelfie).on('click', function (evt) {
        if ($(this).data('locked') === true) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          evt.stopPropagation();
        }
      });
    };

    // Bloquea el botón "Siguiente" del paso 3 mostrando un mensaje de error al vendedor
    _blockNextButton(message) {
      const btn = $('button.step_button--next[data-step="3"]');
      btn.prop('disabled', true).addClass('btn-danger').removeClass('btn-primary');

      // Mostrar o actualizar el mensaje de alerta
      let alert = $('#veriff-error-alert');
      if (alert.length === 0) {
        alert = $('<div id="veriff-error-alert" class="alert alert-danger mt-3" role="alert"></div>');
        btn.closest('.step_footer').prepend(alert);
      }
      alert.text(message).show();
    };

    // Rehabilita el botón "Siguiente" y quita el mensaje de error (verificación exitosa)
    _unblockNextButton() {
      const btn = $('button.step_button--next[data-step="3"]');
      btn.prop('disabled', false).removeClass('btn-danger').addClass('btn-primary');
      $('#veriff-error-alert').hide();
    };

    // Datacultr Validation
    bindDatacultrValidation() {
      const operation = this;

      if (this._handleDatacultrClick) {
        document.removeEventListener("click", this._handleDatacultrClick);
      }

      this._handleDatacultrClick = async (evt) => {
        const btn = evt.target.closest(".step_validate_datacultr");
        if (!btn) return;

        evt.stopPropagation();

        const loader = document.querySelector(operation.ui.loader);
        const loanId = btn.dataset.loanId;

        const url =
          btn.dataset.url ||
          (window.Routes && typeof Routes.js_validate_datacultr_path === "function"
            ? Routes.js_validate_datacultr_path()
            : "/js_validate_datacultr");

        if (!loanId) {
          console.warn("[Datacultr] Missing data-loan-id on button");
          return;
        }

        const csrf =
          document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "";

        btn.disabled = true;
        if (loader) loader.classList.remove("d-none");

        try {
          const r = await fetch(url, {
            method: "POST",
            headers: {
              "X-CSRF-Token": csrf,
              "Content-Type": "application/json",
              "Accept": "application/json",
            },
            body: JSON.stringify({ loan_id: Number(loanId) }),
          });

          let data;
          try {
            data = await r.json();
          } catch {
            throw new Error("Respuesta no válida del servidor");
          }

          if (!r.ok) {
            throw new Error(data?.error || `HTTP ${r.status}`);
          }

          if (data.success === true && data.body === true) {
            Swal.fire({
              icon: "success",
              title: "Dispositivo se encuentra registrado en Datacultr",
              confirmButtonText: "OK",
              customClass: { confirmButton: "swal-ok-btn" },
            });
          } else if (data.success === true && data.body === false) {
            Swal.fire({
              icon: "warning",
              title: "Dispositivo no se encuentra registrado en Datacultr",
              confirmButtonText: "OK",
              customClass: { confirmButton: "swal-ok-btn" },
            });
          } else {
            throw new Error("Error al conectarse con Datacultr");
          }
        } catch (e) {
          Swal.fire({
            icon: "error",
            title: e.message || "Error al conectarse con Datacultr",
            confirmButtonText: "OK",
            customClass: { confirmButton: "swal-ok-btn" },
          });
        } finally {
          if (loader) loader.classList.add("d-none");
          btn.disabled = false;
        }
      };

      // Delegate clicks
      document.addEventListener("click", this._handleDatacultrClick);
    };
  };

  window.Loan = Loan;
})();
